import React from "react";
import HomePageInfo from "../../components/homePageInfo/homePageInfo.comp";
import SignUpForm from "../../components/signUpForm/signUpForm.comp";
import "./landingPage.style.scss";

const LandingPage = () => {
    return (
        <div className="landing-page">
            <div className="hero-section">
                <div className="titles">
                    <h1>Super Fun Challenges</h1>
                    <p>Join Awesome Influencers for <strong>Exciting Adventures!</strong></p>
                </div>
                <HomePageInfo/>
            </div>
            <div className="form-input">
                <SignUpForm/>
            </div>
        </div>
    );
};

export default LandingPage;